import { Col, Row, Typography } from "antd";
import React from "react";

const { Title } = Typography;

const Error404 = () => {
  return (
    <div className="flex flex-auto flex-col min-h-full w-screen max-w-7xl p-16 h-full">
      <Row gutter={16}>
        <Col className="gutter-row" span="24">
          <Title level={1} className="text-center">
            404
          </Title>
        </Col>
        <Col className="gutter-row" span="24">
          <p className="text-center">
            No encontramos la página que estás buscando
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default Error404;
